import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import { AppDispatch } from "../../../store";
import {
  createEntity,
  getEntities,
  updateEntity,
} from "./settingsManagement.api";
import {
  fetching,
  resetEntity,
  selectEntityById,
} from "./settingsManagement.reducer";
import { INewSettings } from "@/shared/model/settings.model";
import { Formik } from "formik";
import {
  CCol,
  CForm,
  CFormFeedback,
  CFormLabel,
  CImage,
  CLoadingButton,
  CRow,
} from "@coreui/react-pro";
import { ToastSuccess } from "@/components/shared/toast/Toast";
import CIcon from "@coreui/icons-react";
import { cisCameraPlus } from "@coreui/icons-pro";
import { checkErrorInputFile } from "@/components/shared/AvatarUpload/AvatarUploadContainer";
import { handleUploadImage } from "@/shared/utils/ultils";

const SettingsManagement = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { initialState } = useSelector(
    (state: RootState) => state.settingsReducer
  );
  const { filterState, updateEntitySuccess, deleteEntitySuccess, loading } =
    initialState;
  const setting = useSelector(selectEntityById("1"));

  useEffect(() => {
    if (!deleteEntitySuccess) {
      dispatch(fetching());
      dispatch(getEntities(filterState));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(filterState)]);

  useEffect(() => {
    dispatch(getEntities(filterState));
  }, []);

  useEffect(() => {
    if (updateEntitySuccess) {
      dispatch(getEntities(filterState));
      ToastSuccess("Cập nhật cấu hình thành công!");
      dispatch(resetEntity());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateEntitySuccess]);

  const initialValues: INewSettings = {
    cardName: "",
  };

  const handleFileUploadAvatar = async (
    e: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: (
      field: string,
      value: any,
      shouldValidate?: boolean | undefined
    ) => void
  ) => {
    const inputFiles = e.target.files;
    if (inputFiles && inputFiles[0]) {
      if (!checkErrorInputFile([inputFiles[0]])) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        setFieldValue("fileContent1", inputFiles[0]);
        setFieldValue("content1", e.target?.result);
      };
      reader.readAsDataURL(inputFiles[0]);
    }
  };

  const handleRemappingImageValue = async (value: any) => {
    if (value.fileContent1) {
      const avatarUrlPromises = await handleUploadImage(value.fileContent1);
      value.content1 = avatarUrlPromises;
    }
    return value;
  };

  if (!setting) return <></>;

  return (
    <>
      <div className="tab-outlet-content">
        <div className="table-content">
          <Formik
            initialValues={setting || initialValues}
            validateOnBlur={false}
            onSubmit={async (value) => {
              const values = await handleRemappingImageValue(value);
              dispatch(fetching());
              if (setting) {
                dispatch(updateEntity(values as any));
              } else {
                dispatch(createEntity(values));
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              resetForm,
              setFieldValue,
            }) => (
              <CForm onSubmit={handleSubmit} className="custom-form">
                <>
                  <CRow className="g-3">
                    <CRow>
                      <CCol xs={6}>
                        <CFormLabel className="fw-bold text-sm mb-0 required-field text-black">
                          Ảnh tham vấn
                        </CFormLabel>
                        <div
                          className="d-flex justify-content-center"
                          style={{ background: "#f6f6f6" }}
                        >
                          <div className="profileImageContainer">
                            <div
                              className="position-relative"
                              style={{ height: 200 }}
                            >
                              {values.content1 ? (
                                <CImage
                                  color="secondary"
                                  rounded
                                  className="image-xxl object-fit-cover"
                                  src={values.content1}
                                  style={{ width: "100%", height: "100%" }}
                                />
                              ) : (
                                <div
                                  className="d-flex flex-column justify-content-center align-items-center"
                                  style={{ width: "100%", height: "100%" }}
                                >
                                  <CIcon
                                    icon={cisCameraPlus}
                                    className="mb-3 text-black"
                                    style={{ width: "33px", height: "33px" }}
                                  />
                                  <p className="text-black">Chọn ảnh</p>
                                </div>
                              )}
                            </div>
                            <CFormLabel
                              htmlFor="custom-task-file-input"
                              className={`p-image`}
                            >
                              {values.content1 ? (
                                <CIcon
                                  icon={cisCameraPlus}
                                  color="secondary"
                                  className="upload-button"
                                />
                              ) : (
                                <div className="add-image"></div>
                              )}
                              <input
                                id="custom-task-file-input"
                                className="file-upload"
                                type="file"
                                onClick={(e) => (e.currentTarget.value = "")}
                                onChange={(e) =>
                                  handleFileUploadAvatar(e, setFieldValue)
                                }
                                accept="image/*"
                              />
                            </CFormLabel>
                          </div>
                        </div>
                        <CFormFeedback
                          invalid
                          className={
                            !!errors.content1 && touched.content1
                              ? "d-block"
                              : "d-none"
                          }
                        >
                          {errors.content1}
                        </CFormFeedback>
                      </CCol>
                    </CRow>

                    <CCol xs={12}>
                      <CLoadingButton
                        className="btn-custom minw-120 primary-500"
                        type="submit"
                      >
                        Lưu cấu hình
                      </CLoadingButton>
                    </CCol>
                  </CRow>
                </>
              </CForm>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default SettingsManagement;
